import http from '../plugins/axios'

export const getAllQcList = async (params) => {
  try {
    const response = await http.get(`/api/v2/quality-control`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const addOrderQc = async (payload) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }
  try {
    const response = await http.post(`/api/v2/quality-control`, payload, config)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteQcItem = async (qcId) => {
  try {
    const response = await http.delete(`/api/v2/quality-control/items/${qcId}`)
    return response.data
  } catch(error) {
    throw error
  }
}